import { render, staticRenderFns } from "./GallerySocial.vue?vue&type=template&id=2f41d20e&scoped=true&"
import script from "./GallerySocial.vue?vue&type=script&lang=js&"
export * from "./GallerySocial.vue?vue&type=script&lang=js&"
import style0 from "./GallerySocial.vue?vue&type=style&index=0&id=2f41d20e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f41d20e",
  null
  
)

export default component.exports